import React, { Component } from 'react';

import './index.less';

export default class DraggableModal extends Component {
  modalRef = React.createRef();

  componentDidMount() {
    window.addEventListener('resize', this.onWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
  }

  onWindowResize = () => {
    this.setStyleInset();
  };

  setStyleInset = (x, y) => {
    const rect = this.modalRef.current.getBoundingClientRect();

    // Constrain within viewport
    const minLeft = 0;
    const minTop = 0;
    const maxLeft = window.innerWidth - rect.width;
    const maxTop = window.innerHeight - rect.height;

    const left = Math.max(minLeft, Math.min(x || rect.left, maxLeft));
    const top = Math.max(minTop, Math.min(y || rect.top, maxTop));

    this.modalRef.current.style.inset = `${top}px auto auto ${left}px`;
  };

  onDrag = (onMouseDownEvent) => {
    let isDragging = true;
    const rect = this.modalRef.current.getBoundingClientRect();
    const offset = {
      x: onMouseDownEvent.clientX - rect.left,
      y: onMouseDownEvent.clientY - rect.top,
    };

    const onMouseMove = (onMouseMoveEvent) => {
      if (!isDragging) return;

      this.setStyleInset(onMouseMoveEvent.clientX - offset.x, onMouseMoveEvent.clientY - offset.y);
    };

    const onMouseUp = () => {
      isDragging = false;
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  onResize = (onMouseDownEvent, dir) => {
    onMouseDownEvent.stopPropagation();

    let isResizing = true;
    const rect = this.modalRef.current.getBoundingClientRect();
    const mouseStart = {
      x: onMouseDownEvent.clientX,
      y: onMouseDownEvent.clientY,
    };

    const onMouseMove = (onMouseMoveEvent) => {
      if (!isResizing) return;

      const offset = {
        x: Math.max(0, Math.min(onMouseMoveEvent.clientX, window.innerWidth)) - mouseStart.x,
        y: Math.max(0, Math.min(onMouseMoveEvent.clientY, window.innerHeight)) - mouseStart.y,
      };

      let width, height, top, left;

      if (dir.includes('e')) {
        width = rect.width + offset.x;
      }

      if (dir.includes('w')) {
        width = rect.width - offset.x;
        left = rect.left + offset.x;
      }

      if (dir.includes('s')) {
        height = rect.height + offset.y;
      }

      if (dir.includes('n')) {
        height = rect.height - offset.y;
        top = rect.top + offset.y;
      }

      if (width) {
        this.modalRef.current.style.width = width + 'px';
      }

      if (height) {
        this.modalRef.current.style.height = height + 'px';
      }

      this.setStyleInset(left, top);
    };

    const onMouseUp = () => {
      isResizing = false;
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  renderResizers = () => {
    const directions = ['n', 'e', 's', 'w', 'ne', 'se', 'sw', 'nw'];

    return directions.map((dir) => (
      <div
        key={dir}
        className={`resize-handle resize-handle-${dir}`}
        onMouseDown={(event) => this.onResize(event, dir)}
      ></div>
    ));
  };

  render() {
    const { className, resizable = true, children, ...others } = this.props;

    return (
      <div
        className={`draggable-modal ${className || ''}`}
        ref={this.modalRef}
        onMouseDown={this.onDrag}
        {...others}
      >
        {resizable && this.renderResizers()}
        {children}
      </div>
    );
  }
}
